import React from "react";
import { dialog, InfiniteScroll, Progress } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import NavBar from "../../../../components/navbar";
import Table from "../../../../components/Table";
import CollapseView from "./components/CollapseView";
import RightSidebar from "../../../../components/RightSidebar";
import ReportsPresenter from "./ReportsPresenter";
import Select from "react-select";

class ReportsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ReportsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: true,
      total: 0,
      count: 0,
      range: "",
      showMobileFilters: false,
      collection: "report",
      filters: {
        variant: null,
        // add more keys as needed, e.g. status, type, etc.
      },
    };
  }

  getCollectionName() {
    return this.state.collection;
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  closeDialog() {
    dialog.close();
  }

  onClickImport() {
    this.presenter.onClickImport();
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.searchSubmit(where);
  }

  onCollapse(index) {
    const audit = this.state.objects[index];
    return <CollapseView audit={audit} />;
  }

  formatFields(fields) {
    const { user, ...rest } = fields;

    return {
      user: { type: "String", label: "User" },
      ...rest,
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      const { ...rest } = object || {};

      return {
        ...rest,
        user: object.user?.email || "N/A",
      };
    });
  }

  searchSubmit(where) {
    this.presenter.searchSubmit(this.getCollectionName());
  }

  onSelectFilter(field, option) {
    const selected = option?.value ?? null;

    const variantToCollection = {
      fc_variant: "fc_variant",
    };

    const nextCollection = selected
      ? variantToCollection[selected] || "report"
      : "report";

    console.log("next", nextCollection);

    this.setState(
      (prev) => ({
        filters: { ...prev.filters, [field]: option || null },
        collection: nextCollection,
      }),
      () => {
        this.searchSubmit({});
      }
    );
  }

  clearAllFilters() {
    this.setState({ filters: { variant: null } }, () => this.searchSubmit({}));
  }

  getVariantOptions() {
    return [{ label: "FC VARIANT", value: "fc_variant" }];
  }

  // Example boolean options you might add later
  getBooleanOptions() {
    return [
      { label: "Any", value: null },
      { label: "Yes / True", value: true },
      { label: "No / False", value: false },
    ];
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading } = this.state;
    console.log("objects", objects);

    if (!schema) return <Progress />;
    return (
      <>
        <NavBar
          action={() => {
            return (
              <div className="dropdown dropstart d-inline-block">
                <i
                  role="button"
                  data-bs-toggle="dropdown"
                  className="bi bi-three-dots-vertical"
                ></i>
                <div className="dropdown-menu fs-xs ">
                  <button
                    onClick={this.onClickExport.bind(this)}
                    className="dropdown-item py-3"
                    style={{ backgroundColor: "#82c14a", color: "white" }}
                  >
                    <i className="fas fa-file-csv me-2"></i>
                    Export Data
                  </button>
                </div>
              </div>
            );
          }}
        />
        <RightSidebar
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          range={this.state.range}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  className="fw-bold text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  Reports
                </h1>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <div style={{ minWidth: 240 }}>
                  {/* <label className="form-label mb-1">Variant</label> */}
                  <Select
                    options={this.getVariantOptions()}
                    value={this.state.filters.variant}
                    onChange={(opt) => this.onSelectFilter("variant", opt)}
                    isClearable
                    placeholder="Select Report..."
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="text-nowrap mt-3">
                  <i
                    className="bi bi-filter fs-1"
                    onClick={() => this.setState({ showMobileFilters: true })}
                    style={{ color: "#83c14a" }}
                  ></i>
                </div>
              </div>

              <Table
                fields={this.formatFields(schema.fields)}
                objects={this.formatObjects(objects)}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "password",
                    "message",
                    "collection",
                    "objectId",
                    "user",
                    "storeId",
                    "variantId",
                    "variantDate",
                    "lastActualCountAt",
                    "physicalCount",
                    "id",
                    "created",
                    "updated",
                  ]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                progress={loading}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
              {objects?.length <= 0 && (
                <div className="text-center align-items-center mt-4">
                  <img
                    src="/choosefirst.png"
                    style={{ height: "200px", width: "200px" }}
                  />
                  <h4 className="mt-4 fw-semibold text-muted text-center">
                    👋 To get started, please select a{" "}
                    <span className="text-success">Report</span> and after that
                    select{" "}
                    <span className="text-success">
                      Date Range in{" "}
                      <i
                        className="bi bi-filter fs-1"
                        style={{ color: "#83c14a" }}
                      ></i>
                    </span>{" "}
                    above.
                  </h4>
                </div>
              )}
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ReportsPage);
